import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { UpgradePopup } from './UpgradePopup';

export const UPGRADE_POPUP = Symbol('UPGRADE');

export const useUpgradePopup = ({ actionsOrigin, originObject, variant, brandVoiceId } = {}) => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(UPGRADE_POPUP, UpgradePopup);
  });

  return useCallback(
    (feature) => {
      return new Promise((resolve) => {
        popups.openPopup(UPGRADE_POPUP, {
          onSubmit: () => {
            popups.closeAllPopups();
            resolve();
          },
          onClose: () => {
            popups.closePopup(UPGRADE_POPUP);
            resolve();
          },
          feature,
          actionsOrigin,
          originObject,
          variant,
          brandVoiceId,
        });
      });
    },
    [popups, actionsOrigin, variant, originObject, brandVoiceId]
  );
};
